import React from "react";
import { DialogContentErrorText } from "../../../functions/errorHandling";

interface IIntegrationDialogErrorProps {
  errorMessage: string;
}

export const IntegrationDialogError = (props: IIntegrationDialogErrorProps): JSX.Element => {
  const { errorMessage } = props;

  return <DialogContentErrorText>{errorMessage}</DialogContentErrorText>;
};
